import {
  Component,
  Input,
  HostBinding,
  Output,
  EventEmitter
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ButtonRadioChange } from './button-radio-change.class';


@Component({
  selector: 'suka-button-radio',
  template: `
    <input
      *ngIf="!skeleton"
      class="button-radio"
      type="radio"
      [checked]="checked"
      [disabled]="disabled"
      [name]="name"
      [id]="id"
      [required]="required"
      [value]="value"
      [attr.aria-labelledby]="ariaLabelledby"
      (change)="onChange($event)">
    <div *ngIf="skeleton" class="button-radio skeleton"></div>
    <label
      class="button-radio__label"
      [ngClass]="{
        'skeleton': skeleton
      }"
      [for]="id"
      id="label-{{id}}">
      <ng-content></ng-content>
    </label>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ButtonRadio,
      multi: true
    }
  ]
})
// tslint:disable-next-line: component-class-suffix
export class ButtonRadio {
  /**
   * Used to dynamically create unique ids for the `ButtonRadio`.
   */
  static buttonRadioCount = 0;

  @Input() checked = false;

  @Input() name = '';

  @Input() disabled = false;

  @Input() set ariaLabelledby(value: string) {
    this._labelledby = value;
  }

  get ariaLabelledby() {
    if (this._labelledby) {
      return this._labelledby;
    }
    return `label-${this.id}`;
  }
  /**
   * Sets the HTML required attribute
   */
  @Input() required = false;
  /**
   * The value of the `Radio`.
   */
  @Input() value = '';
  /**
   * Set to `true` for a loading table.
   */
  @Input() skeleton = false;
  /**
   * The id for the `Radio`.
   */
  @Input() id = `button-radio-${ButtonRadio.buttonRadioCount++}`;
  /**
   * emits when the state of the radio changes
   */
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter<ButtonRadioChange>();
  /**
   * Binds 'radio' value to the role attribute for `Radio`.
   */
  @HostBinding('attr.role') role = 'radio';

  @HostBinding('class.button-radio-wrapper') hostClass = true;

  // tslint:disable-next-line: variable-name
  protected _labelledby = '';

  /**
   * Handler provided by the `ButtonRadioGroup` to bubble events up
   */
  buttonRadioChangeHandler = (event: ButtonRadioChange) => { };

  /**
   * Synchronizes with the `ButtonRadioGroup` in the event of a changed `ButtonRadio`.
   * Emits the changes of both the `ButtonRadioGroup` and `ButtonRadio`.
   */
  onChange(event: Event) {
    event.stopPropagation();
    this.checked = (event.target as HTMLInputElement).checked;
    const ButtonRadioEvent = new ButtonRadioChange(this, this.value);
    this.change.emit(ButtonRadioEvent);
    this.buttonRadioChangeHandler(ButtonRadioEvent);
  }

  /**
   * Method called by `ButtonRadioGroup` with a callback function to bubble `ButtonRadioChange` events
   * @param fn callback that expects a `ButtonRadioChange` as an argument
   */
  registerButtonRadioChangeHandler(fn: (event: ButtonRadioChange) => void) {
    this.buttonRadioChangeHandler = fn;
  }
}
